import React, { FunctionComponent } from 'react';

import { NewTab } from '@yandex-360/iconostasis/dist/icons/NewTab';
import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { ListItem } from '@yandex-360/orb-components/dist/components/ListItem/bundle';
import { UserPic } from '@yandex-360/orb-components/dist/components/UserPic';
import { ConferenceStatus } from '@yandex-360/telemost-sdk';
import { useSelector } from 'react-redux';

import { getConferenceStatus, selectYaServices } from '../../../../../../../../pages/call/selectors';
import { i18n } from '../../../../../../../helpers/i18n';
import { countMetrika } from '../../../../../../../helpers/metrika';
import { selectAvatarsOrigin } from '../../../../../../config/selectors';
import { User } from '../../../../../../user';
import { Heading } from '../../../heading';
import { Island } from '../../../island';
import { getAccountUserPicProps } from './get-account-user-pic-props';
import { NewUiSection } from './new-ui';
import css from './styles.css';

export interface AccountLoggedInProps {
    user: User;
}

export const AccountLoggedIn: FunctionComponent<AccountLoggedInProps> = ({ user }) => {
    const yaServices = useSelector(selectYaServices);
    const avatarsOrigin = useSelector(selectAvatarsOrigin);
    const conferenceStatus = useSelector(getConferenceStatus);

    const idUrl = yaServices.id;
    const retPath = encodeURIComponent(window.location.href);
    const isJoined = conferenceStatus === ConferenceStatus.JOINED;

    const editUrl = isJoined
        ? `${idUrl}/personal?dialog=personal-data&origin=b2b360&retpath=${idUrl}`
        : `${idUrl}/personal?dialog=personal-data&origin=b2b360&retpath=${retPath}`;

    return (
        <div className={css.accountWrapper}>
            <Island className={css.accountSettingsWrapper}>
                <Heading title={i18n('settings-v2', 'section-account-title')} />
                <ListItem
                    className={css.info}
                    label={user.displayName}
                    labelMaxLines={1}
                    description={user.login}
                    descriptionMaxLines={1}
                    interaction={false}
                    startSlot={<UserPic host={avatarsOrigin} size="20m" {...getAccountUserPicProps(user)} />}
                    endSlot={
                        <Button
                            elementType="a"
                            view="neutral"
                            size="md"
                            testId="account-edit-button"
                            iconLeft={<NewTab size="sm" />}
                            href={editUrl}
                            target={isJoined ? '_blank' : '_self'}
                            onPress={() =>
                                countMetrika(
                                    isJoined ? 'meeting_screen' : 'main_screen',
                                    'settings',
                                    'change_name_avatar'
                                )
                            }
                        >
                            {i18n('settings-v2', 'account-edit')}
                        </Button>
                    }
                />
            </Island>
            <NewUiSection />
        </div>
    );
};
